import { UsersClient } from '@empathybroker/tsclient-users';
import { UserResponse } from '@empathybroker/tsclient-users/dist/models/user-response';

import { ActionContext } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { ActionClass, AuthTokenInfo, UserState } from '../../../models';

import { AUTH_CONSTS } from '../../../store/auth/auth.consts';
import { USER_CONSTS } from '../../../store/user/user.consts';

export class LoadUserAction implements ActionClass {

  public static async execute({ commit, rootGetters }: ActionContext<UserState, any>): Promise<UserResponse> {
    try {
      const usersClient = CONTAINER.get<UsersClient>(TYPES.UsersClient);
      const authToken: string = rootGetters[`${ AUTH_CONSTS.moduleName }/${ AUTH_CONSTS.getters.token }`];
      const authTokenInfo: AuthTokenInfo = rootGetters[`${ AUTH_CONSTS.moduleName }/${ AUTH_CONSTS.getters.tokenInfo }`];
      const usersResponse: UserResponse = await usersClient.read(authToken, authTokenInfo.user.id);
      commit(USER_CONSTS.mutations.setUser, usersResponse.data);
      return usersResponse;
    } catch (error) {
      throw error;
    }
  }

}
